import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class EmailStatusBadge extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            status:  this.props.status || '',
            className: this.props.className || '',
            events: this.props.events || [],
            customStyle: this.props.customStyle || {},
            errorMessage: this.props.errorMessage || '',
        }

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            status:  nextProps.status || '',
            className: nextProps.className || '',
            events: nextProps.events || [],
            customStyle: nextProps.customStyle || {},
            errorMessage: nextProps.errorMessage || '',
        })
    }

    renderStatus() {
        switch (this.state.status) {
            case 'created':
                return <div className="badge badge-pill badge-info text-with-icon">
                    <FormattedMessage
                        id="email.status.created_label"
                        defaultMessage="Created"
                    />
                </div>
            case 'sent':
                return <div className="badge badge-pill badge-info text-with-icon">
                    <FormattedMessage
                        id="email.status.sent_label"
                        defaultMessage="Sent"
                    />
                </div>
            case 'delivered':
                return <div className="badge badge-pill badge-info text-with-icon">
                    <FormattedMessage
                        id="email.status.delivered_label"
                        defaultMessage="Delivered"
                    />
                </div>
            case 'opened':
            case 'clicked':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="email.status.read_label"
                        defaultMessage="Read"
                    />
                </div>
            case 'error':
                return <div className="badge badge-pill badge-danger text-with-icon" tabIndex="0" data-toggle="tooltip" title={this.state.errorMessage}>
                        <FormattedMessage
                            id="email.status.error_label"
                            defaultMessage="Bounced"
                        />
                </div>
            case 'spam-reported':
                return <div className="badge badge-pill badge-danger text-with-icon">
                    <FormattedMessage
                        id="email.status.spam_reported_label"
                        defaultMessage="Reported as spam"
                    />
                </div>
        }
        return <div></div>
    }

    render() {
        return <span className={this.state.className} style={this.state.customStyle}>
            {this.renderStatus()}
        </span>
    }

}

export default EmailStatusBadge





// WEBPACK FOOTER //
// ./src/common/email/status.component.jsx